module.exports = __webpack_public_path__ + "924aee37dda23b4f311253d1fe48563b.svg";